const { get, set } = require('@sigma-legacy-libs/no-lodash')

/**
 * @typedef {{[key: string]: Handler}} MappedHandlers
 */
/**
 * @typedef {(value: any, map: MappedHandlers) => any} Handler
 */
/**
 * @typedef {{
 *  mutate?: boolean
 * }} Parameters
 */

class MappedProcessor {
  /**
   * @param {MappedHandlers} map 
   * @param {Parameters} parameters 
   */
  constructor(map, parameters = {}) {
    this.map = map
    this.parameters = parameters
  }

  /**
   * @param {object} object 
   * @param {Parameters} parameters 
   * @returns 
   */
  process(object, parameters = {}) {
    return MappedProcessor.process(object, this.map, Object.assign({}, this.parameters, parameters))
  }

  static get MappedProcessorSync() {
    return MappedProcessorSync
  }

  /**
   * @param {object} object 
   * @param {MappedHandlers} map 
   * @param {Parameters} [parameters={}]
   */
  static async process(object, map, parameters = {}) {
    const { mutate = false } = parameters

    const result = mutate ? object : {}
    const errors = []

    await Promise.allSettled(Object.entries(map).map(async ([ key, handler ]) => {
      const value = get(object, key)

      try {
        const resultValue = await handler(value, map)
        if (typeof resultValue !== 'undefined') {
          set(result, key, resultValue)
        }
      } catch (error) {
        errors.push(error)
      }
    }))

    if (errors.length) {
      throw new Error(errors.join('\n'))
    }

    return result
  }
}

class MappedProcessorSync extends MappedProcessor {
  /**
   * @param {object} object 
   * @param {MappedHandlers} map 
   * @param {Parameters} [parameters={}]
   */
  static process(object, map, parameters = {}) {
    const { mutate = false } = parameters

    const result = mutate ? object : {}
    const errors = []

    for (const [ key, handler ] of Object.entries(map)) {
      try {
        const value = get(object, key)
        const resultValue = handler(value, map)
        if (typeof resultValue !== 'undefined') {
          set(result, key, resultValue)
        }
      } catch (error) {
        errors.push(error)
      }
    }

    if (errors.length) {
      throw new Error(errors.join('\n'))
    }

    return result
  }
}

module.exports = MappedProcessor
